import $ from 'jquery'
import { cssReverse, cssTo } from '../util/El'

const css = {
  overlay: {
    from: 'scale-y-0',
    to: 'scale-y-100',
  },
  subnav: {
    from: 'invisible opacity-0',
    to: 'opacity-100',
  },
  parentEl: {
    from: '',
    to: 'text-gold',
  },
  parentElLine: {
    from: '',
    to: 'scale-x-100',
  },
  mobileNavWrap: {
    from: 'h-0',
    to: 'h-screen',
  },
  mobileOverlay: {
    from: 'scale-y-0',
    to: 'scale-y-100',
  },
  mobileNav: {
    from: 'invisible opacity-0 translate-y-12',
    to: 'visible opacity-100 translate-y-0',
  },
}

export default new class {

  constructor () {
    this.$wrapper = $('[data-nav-header]')
    this.$active = null
    this.delay = 750
    this.timer = null
    this.$mobileTrigger = null
    this.isMobileOpen = false
  }

  init () {
    /**
     * Sub menu
     */
    this.$overlay = $('.js-sub-nav-overlay')
    this.$wrapper.on('mouseover', 'li:not([data-nav-dropdown])', () => {
      this.deactivate()
    })
    $('#primaryHeader').on('mouseleave', () => {
      this.deactivate()
    })
    this.$wrapper.on('mouseover', '[data-nav-dropdown]', (e) => {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      if (this.$active) {
        this.deactivate()
      }
      this.$active = $(e.currentTarget)
      cssTo(this.$active.find('.nav-item__text'), css.parentEl)
      cssTo(this.$active.find('.nav-item__line'), css.parentElLine)
      let $subNav = this.$active.find('.js-sub-nav')
      this.$activeSubNav = $subNav
      this.activate()
    })
    this.$wrapper.on('mouseout', '[data-nav-dropdown]', () => {
      this.timer = setTimeout(() => {
        this.deactivate()
      }, this.delay);
    })
    this.$overlay.on('mouseover', () => {
      if (this.timer) {
        clearTimeout(this.timer)
      }
    })
    this.$overlay.on('mouseout', () => {
      this.timer = setTimeout(() => {
        this.deactivate()
      }, this.delay);
    })
    /**
     * Mobile
     */
    this.$mobileTrigger = $('.js-mobile-trigger')
    this.$mobileTrigger.on('click', () => {
      if (this.isMobileOpen) {
        this.closeMobileNav()
      } else {
        this.openMobileNav()
      }
    })
  }

  onHeadroomPin () {
    this.deactivate()
  }

  onHeadroomUnpin () {
    this.deactivate()
  }

  activate () {
    cssTo(this.$overlay, css.overlay)
    cssTo(this.$activeSubNav, css.subnav)
  }

  deactivate () {
    cssReverse(this.$overlay, css.overlay)
    cssReverse(this.$activeSubNav, css.subnav)
    if (this.$active) {
      cssReverse(this.$active.find('.nav-item__text'), css.parentEl)
      cssReverse(this.$active.find('.nav-item__line'), css.parentElLine)
    }
  }

  openMobileNav () {
    this.$mobileTrigger.addClass('is-active')
    cssTo($('#mobileNavWrap'), css.mobileNavWrap)
    cssTo($('.js-mobile-overlay'), css.mobileOverlay)
    cssTo($('.js-mobile-nav'), css.mobileNav)
    this.isMobileOpen = true
  }

  closeMobileNav() {
    this.$mobileTrigger.removeClass('is-active')
    cssReverse($('.js-mobile-overlay'), css.mobileOverlay)
    cssReverse($('.js-mobile-nav'), css.mobileNav)
    this.isMobileOpen = false
    setTimeout(() => {
      cssReverse($('#mobileNavWrap'), css.mobileNavWrap)
    }, 500);
  }

}
